import { DataGrid } from "devextreme-react";
import { Column } from "devextreme-react/data-grid";
import { cellRenderer, customHeader } from "./SARGrid";
import { formatDate, formatNumber } from "devextreme/localization";
import type { TranchRecommendedExercised } from "@/types/types";

type Props = { recommended: TranchRecommendedExercised[] | undefined };

export default function SarRecommendedExerciseScheduleGrid({ recommended }: Props) {
  return (
    <div className="flex-1">
      <h2 className="pb-4 text-lg font-medium">Recommended Exercise Schedule</h2>
      <DataGrid
        dataSource={recommended ?? []}
        showBorders={true}
        showRowLines={true}
        showColumnLines={true}
        className="ao-grid"
        wordWrapEnabled={true}
        onCellPrepared={(e) => {
          if (e.rowType === "header") {
            e.cellElement.style.backgroundColor = "var(--primary-color)";
            e.cellElement.style.color = "white";
          }
        }}
      >
        <Column
          dataField="date"
          allowSorting={false}
          allowEditing={true}
          alignment={"center"}
          minWidth={100}
          headerCellRender={() => customHeader(``, "Date")}
          dataType={"date"}
          cellRender={(cellData) => {
            return cellData.data?.dateExercised
              ? cellRenderer(
                  cellData,
                  "date-of-grant",
                  formatDate(new Date(cellData?.data?.dateExercised), "MMM dd, yyyy")
                )
              : "";
          }}
        />
        <Column
          dataField="shares"
          allowSorting={false}
          allowEditing={true}
          alignment={"center"}
          dataType={"number"}
          minWidth={100}
          headerCellRender={() => customHeader(``, "Quantity")}
          cellRender={(cellData) => {
            return cellData.data?.shares
              ? cellRenderer(cellData, ``, formatNumber(cellData.data?.shares, "0#"))
              : "";
          }}
        />
        <Column
          dataField="price"
          allowSorting={false}
          allowEditing={true}
          alignment={"center"}
          minWidth={100}
          headerCellRender={() => customHeader(``, "Price")}
          cellRender={(cellData) => {
            return cellData.data?.price
              ? cellRenderer(
                  cellData,
                  `price-${cellData?.externalCode}`,
                  formatNumber(cellData.data?.price, "$0#.##")
                )
              : "";
          }}
        />
      </DataGrid>
    </div>
  );
}
